// import React from 'react';
// import ExcelEditor from './ExcelEditor';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <ExcelEditor />
//     </div>
//   );
// }

// export default App;

//EnhanceExcelEditor 
// import React from 'react';
// import EnhancedExcelEditor from './EnhancedExcelEditor';
// import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
// import './App.css';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#1976d2',
//     },
//     secondary: {
//       main: '#dc004e',
//     },
//   },
// });

// function App() {
//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <div className="App">
//         <EnhancedExcelEditor />
//       </div>
//     </ThemeProvider>
//   );
// }

// export default App;

// AntdExcelEditor 
import React from 'react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import AntdExcelEditor from './AntdExcelEditor';
import './App.css';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');
function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <div className="App">
        <AntdExcelEditor />
      </div>
    </ConfigProvider>
  );
}

export default App;